const currentState = {
    evaluations: {
        data: null,
        error: null
    },
    evaluationCategories: {
        data: null,
        error: null
    },
    evaluationStatuses: {
        data: null,
        error: null
    },
    evaluationYearHistory: {
        data: null,
        error: null
    },
    companyGroups: {
        data: null,
        error: null
    }
};

const reducer = (state = currentState, action) => {
    switch(action.type) {
        case 'INSTANTIATE_EVALUATIONS':
            const evaluations = {...state.evaluations};
            
            if(null !== action.payload.evaluations) 
                evaluations.data = action.payload.evaluations;
            
            evaluations.error = action.payload.error ?? false;

            return {
                ...state,
                evaluations: evaluations
            };
        case 'INSTANTIATE_EVALUATION_CATEGORIES':
            const categories = {...state.evaluationCategories};
            categories.data = action.payload.categories;
            categories.error = action.payload.error ?? false;

            return {
                ...state,
                evaluationCategories: categories
            };
        case 'INSTANTIATE_STATUSES':
            const statuses = {...state.evaluationStatuses};
            statuses.data = action.payload.statuses;
            statuses.error = action.payload.error ?? false;

            return {
                ...state,
                evaluationStatuses: statuses
            };
        case 'INSTANTIATE_GROUPS_EVALUATION':
            const groups = {...state.companyGroups};
            groups.data = action.payload.groups;
            groups.error = action.payload.error;

            return {
                ...state,
                companyGroups: groups
            };
        case 'CREATE_EVALUATION':
            const currentEvaluations = {...state.evaluations};
            const evaluationData = currentEvaluations.data

            evaluationData.unshift(action.payload);
            currentEvaluations.data = evaluationData;

            return {
                ...state,
                evaluations: currentEvaluations
            }
        case 'UPDATE_EVALUATION':
            const apps = {...state.evaluations};
            const _data = apps.data

            const ind = _data.findIndex(evaluation => evaluation.id === action.payload.id);
            _data.splice(ind, 1, action.payload);

            apps.data = _data;

            return {
                ...state,
                evaluations: apps
            }
        case 'DELETE_EVALUATION':
            const pristineEvaluations = {...state.evaluations};
            const data = [...pristineEvaluations.data];
            const index = data.findIndex(evaluation => evaluation.id === action.payload);

            data.splice(index, 1);
            pristineEvaluations.data = data;

            return {
                ...state,
                evaluations: pristineEvaluations
            }
        case 'RESET_EVALUATION':
            const _ = {...state.evaluations};
            _.data = null;
            _.error = null;

            return {
                ...state,
                evaluations: _
            };
        default:
            return state;
    }
};

export default reducer;